import {
	RESET_STATE,
	SET_COMPANIES,
	SET_COMPANIES_SEARCH_VALUE,
	SET_COMPANIES_TYPES,
	SET_COMPANY_ADMIN_SETTINGS,
	SET_COMPANY_INFO,
	SET_COMPANY_SETTINGS,
	SET_IS_COMPANIES_LOADING,
	SET_IS_COMPANIES_TYPES_LOADING,
	SET_IS_COMPANY_ADMIN_SETTINGS_LOADING,
	SET_IS_COMPANY_ADMIN_SETTINGS_SAVING,
	SET_IS_COMPANY_ABOUT_LOADING,
	SET_IS_COMPANY_INFO_LOADING,
	SET_IS_COMPANY_SAVING,
	SET_IS_COMPANY_SETTINGS_LOADING,
	SET_IS_COMPANY_SETTINGS_SAVING,
	SET_IS_ORG_TYPES_LOADING,
	SET_IS_TAX_RATES_LOADING,
	SET_IS_TAX_SYSTEMS_LOADING,
	SET_ORG_TYPES,
	SET_TAX_RATES,
	SET_TAX_SYSTEMS,
	SET_COMPANIES_ABOUT,
	GET_DELIVERY_TYPES,
	GET_CAR_TYPES,
	GET_TONNAGES_TYPES,
	GET_MODES_TYPES,
	SET_IS_MODES_TYPES_LOADING,
	SET_IS_TONNAGES_TYPES_LOADING,
	SET_IS_DELIVERY_TYPES_LOADING,
	SET_IS_CAR_TYPES_LOADING,
	SET_IS_COMPANIES_PATCH_LOADING,
	SET_STAGES,
	SET_IS_STAGES_LOADING,
	SET_DOCUMENTS_TYPES,
	SET_IS_DOCUMENTS_TYPES_LOADING,
} from './actions';

export const initialState = {
	companyInfo: null,
	isCompanyInfoLoading: false,
	isCompanySaving: false,
	companiesTypes: [],
	isCompaniesTypesLoading: false,
	isCompaniesLoading: false,
	isCompaniesPatchLoading: false,
	orgTypes: [],
	carTypes: [],
	deliveryTypes: [],
	tonnagesTypes: [],
	modesTypes: [],
	isCarTypesLoading: false,
	isDeliveryTypesLoading: false,
	isTonnagesTypesLoading: false,
	isModesTypesLoading: false,
	isOrgTypesLoading: false,
	companyInfoAbout: [],
	taxSystems: [],
	isTaxSystemsLoading: false,
	taxRates: [],
	isTaxRatesLoading: false,
	companies: [],
	companiesSearchValue: '',
	companySettingInfo: null,
	isCompanySettingLoading: false,
	isCompanySettingSaving: false,
	companyAdminSettingInfo: null,
	isCompanyAdminSettingLoading: false,
	isCompanyAboutLoading: false,
	isCompanyAdminSettingSaving: false,
	stages: [],
	isStagesLoading: false,
	documentTypes: [],
	isDocumentsTypesLoading: false,
};

const companiesModalReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_COMPANY_INFO:
			return {
				...state,
				companyInfo: payload,
			};
		case SET_IS_COMPANY_INFO_LOADING:
			return {
				...state,
				isCompanyInfoLoading: payload,
			};
		case SET_IS_COMPANY_SAVING:
			return {
				...state,
				isCompanySaving: payload,
			};
		case SET_COMPANIES_TYPES:
			return {
				...state,
				companiesTypes: payload,
			};
		case SET_IS_COMPANIES_TYPES_LOADING:
			return {
				...state,
				isCompaniesTypesLoading: payload,
			};
		case SET_IS_COMPANIES_LOADING:
			return {
				...state,
				isCompaniesLoading: payload,
			};
		case SET_IS_COMPANIES_PATCH_LOADING:
			return {
				...state,
				isCompaniesPatchLoading: payload,
			};
		case SET_COMPANIES:
			return {
				...state,
				companies: payload,
			};
		case SET_COMPANIES_ABOUT:
			return {
				...state,
				companyInfoAbout: payload,
			};
		case SET_COMPANIES_SEARCH_VALUE:
			return {
				...state,
				companiesSearchValue: payload,
			};
		case SET_ORG_TYPES:
			return {
				...state,
				orgTypes: payload,
			};
		case GET_DELIVERY_TYPES:
			return {
				...state,
				deliveryTypes: payload,
			};
		case GET_CAR_TYPES:
			return {
				...state,
				carTypes: payload,
			};
		case GET_TONNAGES_TYPES:
			return {
				...state,
				tonnagesTypes: payload,
			};
		case GET_MODES_TYPES:
			return {
				...state,
				modesTypes: payload,
			};
		case SET_IS_ORG_TYPES_LOADING:
			return {
				...state,
				isOrgTypesLoading: payload,
			};
		case SET_IS_MODES_TYPES_LOADING:
			return {
				...state,
				isModesTypesLoading: payload,
			};
		case SET_IS_TONNAGES_TYPES_LOADING:
			return {
				...state,
				isTonnagesTypesLoading: payload,
			};
		case SET_IS_DELIVERY_TYPES_LOADING:
			return {
				...state,
				isDeliveryTypesLoading: payload,
			};
		case SET_IS_CAR_TYPES_LOADING:
			return {
				...state,
				isCarTypesLoading: payload,
			};
		case SET_TAX_SYSTEMS:
			return {
				...state,
				taxSystems: payload,
			};
		case SET_IS_TAX_SYSTEMS_LOADING:
			return {
				...state,
				isTaxSystemsLoading: payload,
			};
		case SET_TAX_RATES:
			return {
				...state,
				taxRates: payload,
			};
		case SET_IS_TAX_RATES_LOADING:
			return {
				...state,
				isTaxRatesLoading: payload,
			};
		case SET_COMPANY_SETTINGS:
			return {
				...state,
				companySettingInfo: payload,
			};
		case SET_IS_COMPANY_SETTINGS_LOADING:
			return {
				...state,
				isCompanySettingLoading: payload,
			};
		case SET_IS_COMPANY_SETTINGS_SAVING:
			return {
				...state,
				isCompanySettingSaving: payload,
			};
		case SET_COMPANY_ADMIN_SETTINGS:
			return {
				...state,
				companyAdminSettingInfo: payload,
			};
		case SET_IS_COMPANY_ADMIN_SETTINGS_LOADING:
			return {
				...state,
				isCompanyAdminSettingLoading: payload,
			};
		case SET_IS_COMPANY_ABOUT_LOADING:
			return {
				...state,
				isCompanyAboutLoading: payload,
			};
		case SET_IS_COMPANY_ADMIN_SETTINGS_SAVING:
			return {
				...state,
				isCompanyAdminSettingSaving: payload,
			};
		case SET_STAGES:
			return {
				...state,
				stages: payload,
			};
		case SET_IS_STAGES_LOADING:
			return {
				...state,
				isStagesLoading: payload,
			};
		case SET_DOCUMENTS_TYPES:
			return {
				...state,
				documentTypes: payload,
			};
		case SET_IS_DOCUMENTS_TYPES_LOADING:
			return {
				...state,
				isDocumentsTypesLoading: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default companiesModalReducer;
